import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Input, Nav, NavItem, NavLink } from "reactstrap";
import "./refund-order.scss";
import { SetStateAction, useEffect, useState } from "react";
// import ConfirmOrderModal from "./components/ConfirmOrderModal";
// import OrderHistoryCard from "./components/OrderHistoryCard";
import classnames from "classnames";
import axios from "axios";
// import TrackOrder from "./components/TrackOrder";
// import TrackOrderMOdal from "./components/TrackOrder";
import { ToastContainer } from "react-toastify";
import OrderHistoryCard from "../components/OrderHistoryCard";
import filterIcon from "../../../../assets/images/filter-icon.png"
import ReturnOrderCard from "../components/RefundOrderCard";
import RefundOrderCard from "../components/RefundOrderCard";

const RefundOrder = (props: any) => {

    document.title = "Return Order | BuyPass";
    const [counts, setCounts] = useState<any>();
    const [searchTerm, setSearchTerm] = useState("");
    const [orders, setOrders] = useState<any>();
    const [activeTab, setActiveTab] = useState("all");
    var [statusTab, setStatusTab] = useState("all");
    const headerNavigations = [
        {
            label: "All Orders",
            value: "all",
            active: true,
            count: counts?.allCount,
        },
        {
            label: "Return Initiated",
            value: "returnInitiated",
            active: false,
            count: counts?.pendingCount,
        },
        {
            label: "QC in Progress",
            value: "qCInProgress",
            active: false,
            count: counts?.acceptedCount,
        },
        {
            label: "Return in Progress",
            value: "returnInProgress",
            active: false,
            count: counts?.rejectedCount,
        },
        {
            label: "Return to Seller",
            value: "returnToSeller",
            active: false,
            count: counts?.deliveredCount,
        },
        {
            label: "Cancel",
            value: "cancel",
            active: false,
            count: counts?.cancelledCount,
        },
    ];
    const [ConfirmModal, setConfirmModal] = useState(false);
    const [proofModal, setProofModal] = useState(false);
    const [navigations, setNavigations] = useState(headerNavigations[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const itemsPerPage = 10;
    const [activeDayTab, setActiveDayTab] = useState("Today");

    const tabs = ["Today", "Yesterday", "Last 7 Days", "Last 30 Days", "Custom"];

    const onGetOrders = async (page: number) => {
        try {
            const response = await axios.get(
                `api/v1/order/refund?page=${page}&count=${itemsPerPage}&status=${statusTab}&keyword=${searchTerm}`
            );
            if (response?.data) {
                setOrders(response.data.data);
                setCounts(response.data.counts);
                setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
            }
        } catch (err: any) {
        } finally {
        }
    };

    const onGetOrdersWithStatus = async (page: number, status: any) => {
        try {
            const response = await axios.get(
                `api/v1/order/refund?page=${page}&count=${itemsPerPage}&status=${statusTab}&keyword=${searchTerm}`
            );
            if (response?.data) {
                setOrders(response.data.data);
                setCounts(response.data.counts);
                setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
            }
        } catch (err: any) {
        } finally {
        }
    };

    useEffect(() => {
        onGetOrders(currentPage);
    }, [searchTerm, currentPage]);

    return (
        <div className="page-content ordersMainPage">
            <ToastContainer />
            <Container fluid>
                <BreadCrumb
                    title="Refund Orders"
                    pageTitle="Orders"
                    pageTitleRoute="/manage-order"
                />

                {/* <ConfirmOrderModal
          show={ConfirmModal}
          onCloseClick={() => setConfirmModal(false)}
        /> */}

                <Card>
                    <div className="navigatiovCardDv">
                        {/* <h2 >Order History</h2> */}
                        {counts && (
                            <Nav
                                className="nav-tabs nav-tabs-custom nav-success"
                                role="tablist"
                            >
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "all" })}
                                        href="#"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "all");
                                            setActiveTab("all");
                                        }}
                                        data-testing-id="all_orders"
                                    >
                                        All
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.allCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "returnInitiated" })}
                                        href="#"
                                        data-testing-id="newOrderTabar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "returnInitiated");
                                            setActiveTab("returnInitiated");
                                        }}
                                    >
                                        Return Initiated
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.newOrderCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "qCInProgress" })}
                                        href="#"
                                        data-testing-id="pendingTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "qCInProgress");
                                            setActiveTab("qCInProgress");
                                        }}
                                    >
                                        QC in Progress
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.pendingCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "returnInProgress" })}
                                        href="#"
                                        data-testing-id="manualAssignedTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "returnInProgress");
                                            setActiveTab("returnInProgress");
                                        }}
                                    >
                                        Return in Progress
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.pendingCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            active: activeTab === "returnedToSeller",
                                        })}
                                        href="#"
                                        data-testing-id="readyToShipTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "returnedToSeller");
                                            setActiveTab("readyToShip");
                                        }}
                                    >
                                        Returned to Seller
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.readyToShipCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            active: activeTab === "cancel",
                                        })}
                                        href="#"
                                        data-testing-id="acceptedTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "cancel");
                                            setActiveTab("cancel");
                                        }}
                                    >
                                        Cancel
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.acceptedCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        )}

                        <div className="serchNavigationDv">
                            <div className="serchDv">
                                <i className="bx bx-search"></i>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    data-testing-id="serachInput_order"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            {/* <p style={{ fontSize: "14px", margin: "0px", fontWeight: "400", color: "#21262C" }}>Total 10 items</p> */}
                            <div className="paginationDv">
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination detailPagepagi m-0">
                                        {/* Previous Arrow */}
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                style={{ height: '26px', display: "flex", alignItems: 'center', border: "none" }}
                                                className="page-link"
                                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                            >
                                                <i style={{ height: '11px' }} className='bx bxs-left-arrow'></i>
                                            </button>
                                        </li>

                                        {Array.from(
                                            { length: Math.min(totalPages, 5) },
                                            (_, i) => {
                                                const startPage = Math.max(
                                                    Math.min(currentPage - 4, totalPages - 7),
                                                    1
                                                );
                                                return startPage + i;
                                            }
                                        ).map((page) => (
                                            <div>
                                                <li
                                                    className={`page-item ${currentPage === page ? "active" : ""}`}
                                                    key={page}
                                                >
                                                    <button
                                                        style={{ height: '26px' }}
                                                        className="page-link orderPg"
                                                        onClick={() => setCurrentPage(page)}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>
                                            </div>
                                        ))}

                                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                            <button
                                                className="page-link orderPg"
                                                style={{ height: '26px', display: "flex", alignItems: 'center', border: "none" }}
                                                onClick={() =>
                                                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                                                }
                                            >
                                                <i className='bx bxs-right-arrow' style={{ width: '6px', height: '11px' }}></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>

                            </div>
                        </div>
                        <div className="tableHead">
                            <div className="tableHeadChild firtChild">
                                <h4>Product</h4>
                            </div>
                            <div className="contenDv">
                                <div className="tableHeadChild">
                                    <h4>Total Amount</h4>
                                </div>
                                <div className="tableHeadChild">
                                    <h4>Order Status</h4>
                                </div>
                                <div className="tableHeadChild">
                                    <h4>Actions</h4>
                                </div>
                            </div>
                            <div className="tableHeadChild lastChild d-flex cursor-pointer">
                                <img src={filterIcon} style={{width: "13px", height: "13px" , marginRight: "5px"}} alt="" />
                                <h4 className="text-secondary">Filter</h4>
                            </div>
                        </div>
                        {/* <div className="chipTodayContainer">
                            {tabs.map((tab) => (
                                <p
                                    key={tab}
                                    className={`chipDv ${activeTab === tab ? "activeDv" : ""}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </p>
                            ))}
                        </div> */}
                        {/* <div className="inputContainer">
                            <div className="searchWrapper">
                                <Input placeholder="Order ID" />
                                <i className="bx bx-search searchIcon"></i>
                            </div>
                            <div className="searchWrapper">
                                <Input placeholder="Customer Phone" />
                                <i className="bx bx-search searchIcon"></i>
                            </div>
                            <div className="searchWrapper">
                                <select className="dropdown">
                                    <option value="" disabled selected>Logistic Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="shipped">Shipped</option>
                                    <option value="delivered">Delivered</option>
                                    <option value="cancelled">Cancelled</option>
                                </select>
                            </div>
                        </div> */}
                    </div>
                </Card>
                {navigations.label === "All Orders" && (
                    <>
                        {orders && orders.length > 0 ? (
                            orders.map((order: any, index: any) => (
                                <RefundOrderCard
                                    key={order._id}
                                    order={order}
                                    index={index}
                                    activeTab={activeTab}
                                    setOrders={setOrders}
                                    setTotalPages={setTotalPages}
                                />
                            ))
                        ) : (
                            <h2>No Data Found!</h2>
                        )}
                    </>
                )}
            </Container>
        </div>
    );

};

export default RefundOrder;
